import topicsDir from "../__topicsDir";

/**
 * events data
 * イベント一覧データ
 * @props {string} date 日時（YYYY-MM-DD\THH:mm）
 * @props {string} title タイトル（html）
 * @props {string} [href] リンクURL
 */
export default [
	// {
	// 	date: "2020-10-06T08:50",
	// 	title: "イベントタイトルのテキストが入ります",
	// 	href: `${topicsDir}/2020/10-003/`
	// },
	{
		date: "2020-10-12T09:00",
		title: "第7回新潟県在宅医療推進センターコーディネーター研修会【WEB】を開催します",
		href: `${topicsDir}/2020/10-001/`
	},
	{
		date: "2020-10-12T10:00",
		title: "新潟県職能団体在宅医療担当者情報交換会を開催します",
		href: `${topicsDir}/2020/10-002/`
	},
	{
		date: "2020-10-19T11:00",
		title: "新潟県在宅医療推進センター連絡協議会【WEB】を開催します",
		href: `${topicsDir}/2020/10-003/`
	},
	{
		date: "2020-10-26T08:00",
		title: "在宅医療推進センターコーディネーター活動指針ver.1を資料ダウンロードページに掲載しました",
		href: "/contents/download/"
	},
	{
		date: "2020-10-26T09:00",
		title: `
<span>燕市医師会在宅医療推進センターより</span><br>
<a href="${topicsDir}/2020/10-for_tsubameyahiko-no3.pdf">第３回　燕・弥彦在宅医療を考える会のご案内</a><br>
<a href="${topicsDir}/2020/10-acp_hajimenoippo.pdf">ACPはじめの一歩研修会のご案内</a>
		`.trim().replace(/\t|\n/g, "")
	},
	{
		date: "2020-10-26T10:00",
		title: `
<span>しばた地域医療介護連携センターより</span><br>
<a href="${topicsDir}/2020/10-tokinet-r2.pdf">令和2年度ときネット研修会開催のご案内</a>
		`.trim().replace(/\t|\n/g, "")
	}
];
